// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"button-wrapper__3RGma","button":"button__2M6Gd","text":"text__31WAc","body":"body__3AwI9"};